export default __webpack_public_path__ + "1246731355ccf51df8007eedd5ebb52d.svg";